import { useMemo } from 'react';
import { FormSelectField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropdownItem, DropdownItemProps } from '@optimus-web/core';
import { PlatformProfilePrivilegesFlag, useLocalizePlatformProfilePrivilege } from '../Common/privilegesUtils';
import { PlatformProfilesRole } from './RoleField';

export interface PrivilegesFieldProps {
    name: string;
    role: PlatformProfilesRole;
}

export const PrivilegesField = ({ name, role }: PrivilegesFieldProps) => {
    const privilegesOptions = usePrivilegesOptions(role);

    return (
        <FormSelectField name={name} label={<LocalizedText textKey={TextKey.SelectPermissions} />} multiselect required>
            {privilegesOptions.map((option) => (
                <DropdownItem {...option} />
            ))}
        </FormSelectField>
    );
};

const developerPrivilegesOptions: PlatformProfilePrivilegesFlag[] = [
    'extendEHW',
    'manageEnterprises',
    'manageChannelManagerConfigurations',
    'manageCharitySubscriptions',
    'manageContent',
    'manageSubscriptions',
    'managePlatformProfiles',
    'runInstallation',
];

const supportPrivilegesOptions: PlatformProfilePrivilegesFlag[] = [
    'accessAllEnterprises',
    ...developerPrivilegesOptions,
];

const usePrivilegesOptions = (role: PlatformProfilesRole): DropdownItemProps[] => {
    const localizePrivilege = useLocalizePlatformProfilePrivilege();
    const privilegesOptions =
        role === PlatformProfilesRole.Developer ? developerPrivilegesOptions : supportPrivilegesOptions;

    return useMemo(
        () =>
            privilegesOptions.map((privilege) => ({
                key: privilege,
                value: privilege,
                label: localizePrivilege(privilege).label,
            })),
        [privilegesOptions, localizePrivilege]
    );
};
